import { Badge, Typography } from "antd";
import styled from "styled-components";

export const StyledMenu = styled.div`
  margin-right: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-content: space-between;
  height: inherit;
`;

export const StyledBack = styled.div`
  width: 100%;
  margin-left: 20px;
  margin-bottom: 12px;

  div {
    height: 24px;
    width: 22.153846740722656px;
    padding: 5px 8px;
    border-radius: 1000px;
    background: #ffffff;
  }
`;

export const StyledMain = styled.div`
  width: 100%;
`;

export const StyledLogo = styled.div`
  margin-bottom: 10px;
`;

export const StyledMenuIcon = styled.div`
  margin-right: 6%;

  &.active {
    fill: #007bfb;
  }
`;

export const StyledTitle = styled(Typography.Text)`
  color: #2b303b;
`;

export const StyledMenuItem = styled.div`
  width: 216px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 48px;
  padding: 8px 12px;
  margin: 0px 12px;
  cursor: ${(props) =>
    props.className === "none" ? "not-allowed" : "pointer"};

  &:hover {
    border-radius: 8px;
    scale: 0.98;
    background: #e5f2ff;
    transition: 0.1s linear;

    ${StyledTitle} {
      color: #007bfb;
      transition: 0.1s linear;
    }

    ${StyledMenuIcon} {
      fill: #007bfb;
    }
  }

  &.active {
    background: #e5f2ff;
    border-radius: 8px;

    ${StyledTitle} {
      color: #007bfb;
    }
  }
`;

export const StyledMenuTitle = styled.div`
  font-family: "Museo Sans Cyrl";
  display: flex;
  width: 70%;
  align-items: center;
  justify-content: flex-start;
`;

export const StyledBadge = styled(Badge)`
  && .ant-badge-dot {
    width: 10px;
    height: 10px;
    top: 25px;
    left: 200px;
  }
`;
